



























import { Component, Vue } from "vue-property-decorator";
import api from "@/getinfo-api";
import { Course as ICourse } from "@/api/models/course";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CourseForm from "@/components/courses/CourseForm.vue";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api/models/course-document-info";

@Component({
  components: { CourseForm, CBreadCrumbs }
})
export default class courseEditView extends Vue {
  courseId!: string;
  title!: string;
  course!: ICourse;
  fisFRDO!: ICourseDocumentInfo;

  data() {
    return {
      fisFRDO: undefined,
      course: undefined,
      title: undefined,
      courseId: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        to: { name: "courseView", params: { courseId: this.courseId } },
        label: this.$converter.limitedOutput(this.title, 40)
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getCourseInfo() {
    api.CourseApi.get(this.$route.params.courseId)
      .then((res: { data: ICourse }) => {
        this.course = res.data;
        this.courseId = res.data.id;
        this.title = res.data.title;
        document.title += ` ${res.data.title}`;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(this.getCourseDocumentInfo);
  }

  getCourseDocumentInfo() {
    api.CourseApi.getDocumentInfo(this.courseId)
      .then((res: { data: ICourseDocumentInfo }) => {
        this.fisFRDO = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getCourseInfo();
  }
}
